/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import NoiseSource from './noise-source';
import BaseNoiseGroup from '../../implementation-common/base-noise-group';

export default class DeliyannisBandPassNoiseGroup extends BaseNoiseGroup {
  c1;
  c2;
  r1;
  r2;
  r3;
  r4;
  r5;
  opAmp;
  frequencyArray;
  magnitude;

  @computed('c1', 'c2', 'filterAmplitude', 'opAmp', 'r1', 'r2', 'r3', 'r4', 'r5') get noiseReferredToOutputArray() {
    var c1 = this.c1;
    var c2 = this.c2;
    var r1 = this.r1;
    var r2 = this.r2;
    var r3 = this.r3;
    var r4 = this.r4;
    var r5 = this.r5;
    var opAmp = this.opAmp;
    var filterAmplitude = this.filterAmplitude;
    var complexRParallelArray = filterAmplitude.map((item) => {
      return item.complexRParallel;
    });
    var sImaginaryArray = filterAmplitude.map((item) => {
      return item.sImaginary;
    });
    var rxArray = filterAmplitude.map((item) => {
      return item.rx;
    });
    var complexDenominatorArray = filterAmplitude.map((item) => {
      return item.complexDenominator;
    });
    var iNoise = opAmp.iNoise;
    var vNoise = opAmp.vNoise;
    var noiseSource = NoiseSource.create({
      c1: c1,
      c2: c2,
      r1: r1,
      r2: r2,
      r3: r3,
      r4: r4,
      r5: r5,
      opAmp: opAmp,
      iNoise: iNoise,
      vNoise: vNoise,
    });
    var result = filterAmplitude.map((item, index) => {
      var complexRParallel = complexRParallelArray[index];
      var sImaginary = sImaginaryArray[index];
      var rx = rxArray[index];
      var complexDenominator = complexDenominatorArray[index];
      return noiseSource.totalNoise(item, complexDenominator, complexRParallel, rx, sImaginary);
    });

    return result;
  }

  @computed('noiseReferredToOutputArray', 'magnitude', 'frequencyArray') get noiseReferredToInputArray() {
    var frequencyArray = this.frequencyArray;
    var noiseReferredToOutputArray = this.noiseReferredToOutputArray;
    var magnitude = this.magnitude;
    var result = frequencyArray.map((item, index) => {
      var res = noiseReferredToOutputArray[index] / magnitude[index];
      return res;
    });

    return result;
  }
}
